module.exports = __webpack_public_path__ + "img/vet_thumbnail-600x450.8ac55dea.jpg";